import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from '../../../context/FormContext';
import dashboardService from '../services/dashboardService';

/**
 * Dashboard için ana hook
 */
export const useDashboard = () => {
  // State
  const [loading, setLoading] = useState(true);
  const [statsData, setStatsData] = useState({
    totalForms: 0,
    activeForms: 0,
    recordForms: 0,
    archiveForms: 0
  });
  const [isFormUserLoggedIn, setIsFormUserLoggedIn] = useState(false);

  // Redux selectors
  const appToken = useSelector((state) => state.appToken.apptoken);
  const userData = useSelector((state) => state.loginData.loginData);
  
  // Context
  const { forms, setForms } = useFormContext();

  /**
   * Dashboard verilerini yükle
   */
  const fetchFormData = useCallback(async () => {
    setLoading(true);
    try {
      const stats = await dashboardService.fetchDashboardStats(appToken, userData.id);
      setStatsData(stats);
    } catch (error) {
      console.error('Dashboard verileri alınırken hata oluştu:', error);
    } finally {
      setLoading(false);
    }
  }, [appToken, userData.id]);

  /**
   * Form kullanıcısı giriş kontrolü
   */
  const checkFormUserLogin = useCallback(() => {
    const formUserToken = localStorage.getItem('formUserToken');
    const formUserData = localStorage.getItem('formUserData');
    
    if (formUserToken && formUserData) {
      try {
        const parsedUserData = JSON.parse(formUserData);
        if (parsedUserData && parsedUserData.id) {
          setIsFormUserLoggedIn(true);
        }
      } catch (error) {
        console.error('Error parsing stored form user data:', error);
      }
    }
  }, []);

  // İlk yükleme efektleri
  useEffect(() => {
    checkFormUserLogin();
  }, [checkFormUserLogin]);

  useEffect(() => {
    // Kullanıcı verilerini debug için yazdır
    console.log('Dashboard userData:', userData);
    console.log('Logo URL:', userData?.logoUrl);
    console.log('Company Name:', userData?.companyName);
    
    fetchFormData();
  }, [fetchFormData, userData]);

  return {
    // State
    loading,
    statsData,
    isFormUserLoggedIn,
    forms,
    userData,
    
    // Actions
    fetchFormData,
    setForms
  };
};

/**
 * Template kategorileri için hook
 */
export const useTemplateCategories = () => {
  const [activeCategory, setActiveCategory] = useState('Tümü');

  /**
   * Template'leri kategoriye göre filtrele
   */
  const filterTemplatesByCategory = useCallback((templates, category) => {
    return category === 'Tümü' 
      ? templates 
      : templates.filter(template => template.category === category);
  }, []);

  return {
    activeCategory,
    setActiveCategory,
    filterTemplatesByCategory
  };
};
